import { Collapse } from "antd";

import { AccordionVariant, BaseAccordionProps } from "./types";

import "./styles.css";

const BaseAccordion = ({
  className,
  variant = AccordionVariant.FILLED,
  ...props
}: BaseAccordionProps) => {
  return (
    <Collapse
      className={`base-accordion base-accordion-${variant} ${className}`}
      {...props}
    />
  );
};

export default BaseAccordion;
